import React from 'react'
import { Button, Icon, Progress, Spin } from 'antd'
import './StatusView.scss'

/**
 * A reusable view for showing status (loading, error)
 * with a clean, corporate-friendly design.
 */
const StatusView = ({
  status = 'loading', // 'loading' | 'error'
  title,
  subTitle,
  error,
  progress,
  onRetry,
  onClose,
  inline = false,
  small = false
}) => {
  return (
    <div
      className={`status-container ${small ? 'small' : ''} ${
        inline ? 'is-inline' : ''
      }`}
    >
      {status === 'loading' ? (
        <div className="status-view loading-view">
          <div className="loader-container">
            <Spin size="large" />
          </div>
          <div className="text-content">
            <h3 className="status-title">{title || 'Processing...'}</h3>
            {subTitle && <p className="status-subtitle">{subTitle}</p>}
          </div>
          {progress !== undefined && (
            <div className="progress-wrapper">
              <div className="progress-header">
                <span className="progress-label">Progress</span>
                <span className="progress-value">
                  {Math.round(Number(progress) || 0)}%
                </span>
              </div>
              <Progress
                percent={Math.round(Number(progress) || 0)}
                showInfo={false}
                strokeWidth={6}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="status-view error-view">
          <div className="illustration-wrapper">
            <div className="error-icon-container">
              <Icon type="close-circle" theme="filled" />
            </div>
          </div>
          <div className="text-content">
            <h3 className="status-title">{title || 'Something went wrong'}</h3>
            <p className="status-subtitle">
              {subTitle ||
                'We encountered an error while processing your request.'}
            </p>
          </div>

          {error && (
            <div className="error-details">
              <div className="error-scroll-area">
                <span className="error-label">Error Details</span>
                <p className="error-text">{error}</p>
              </div>
            </div>
          )}

          <div className="action-footer">
            {onClose && (
              <Button onClick={onClose} className="btn-secondary">
                Cancel
              </Button>
            )}
            {onRetry && (
              <Button type="primary" onClick={onRetry} className="btn-primary">
                Retry
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default StatusView
